<template>
  <div id="app">
    <transition name="van-fade">
      <router-view/>
    </transition>
  </div>
</template>
<script>

  import { Cell, CellGroup } from 'vant';


  export default {
    components:{
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
    }
  }


</script>
<style lang="scss">
  body{
    font-size: 18px
  }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
